import Chart from "react-apexcharts";
import { Skeleton } from "@mui/material";
import { DashCard } from "./DashCard";
import { colors, fontFamily } from "../../data/tokens";
import { MonthlySeries } from "./useDashboardData";

// Cancelamentos por mês (últimos 12 meses), pela data de cancelamento
// gravada no cadastro. Vermelho da marca: é a série de SAÍDA, em
// oposição ao azul do "Novos sócios por mês" exibido ao lado — série
// única, a cor carrega a polaridade, não identidade de legenda.
export function CancellationsBarChart({
  monthly,
}: {
  monthly: MonthlySeries | null;
}) {
  return (
    <DashCard title="Cancelamentos por mês (últimos 12 meses)">
      {!monthly ? (
        <Skeleton variant="rounded" height={280} />
      ) : (
        <Chart
          type="bar"
          height={300}
          series={[{ name: "Cancelamentos", data: monthly.values }]}
          options={{
            chart: { fontFamily, toolbar: { show: false } },
            colors: [colors.action],
            plotOptions: { bar: { borderRadius: 4, columnWidth: "55%" } },
            dataLabels: { enabled: false },
            xaxis: { categories: monthly.labels },
            yaxis: {
              labels: { formatter: (v: number) => String(Math.round(v)) },
            },
            grid: { borderColor: colors.neutral200 },
            tooltip: {
              y: { formatter: (v: number) => v.toLocaleString("pt-BR") },
            },
          }}
        />
      )}
    </DashCard>
  );
}
